import React, { Component } from 'react'
import { get } from 'lodash'
class PieChart extends Component {
  // constructor(props) {
  //   super(props);
  //   const scores = props.scores;
  //   const descriptions = props.descriptions;
  //   const productCode = props.productCode;
  // }
  componentDidUpdate() {
    this.pieChart(this.props.description)
  }
  componentDidMount() {
    this.pieChart(this.props.descriptions)
    // console.log('DID MOUNT', )
  }

  getLength() {
    var length = 0
    if (window.innerWidth > 1100) {
      length = window.innerWidth / 3.3
    } else if (window.innerWidth > 700) {
      length = window.innerWidth / 2
    } else {
      length = window.innerWidth * 0.8
    }
    return length
  }

  pieChart(descriptions) {
    const chartbaseCircleColor = '#f2f9fc'
    const pieBaseColor = 'rgba(162, 180, 181,0.1)'

    let pieCanvas = document.getElementById('pieCanvas')
    //let pieCanvas2 = document.getElementById("pieCanvas2");
    //document.getElementById('pieCanvas').appendChild(pieCanvas)

    //change the Size of chart to 400 10/24
    // pieCanvas.width = 500;
    // pieCanvas.height = 500;

    //Change the size based on the width of the windows

    // pieCanvas.width = this.getLength();
    // pieCanvas.height = this.getLength();

    //Solve the blurring problem by enlarging the size of canvas and reducing the style size. But it still need to fix the offeset problem.
    pieCanvas.setAttribute('width', this.getLength() * 2)
    pieCanvas.setAttribute('height', this.getLength() * 2)

    pieCanvas.style.width = this.getLength() + 'px'
    pieCanvas.style.height = this.getLength() + 'px'

    // pieCanvas2.width = this.getLength();
    // pieCanvas2.height = this.getLength();

    pieCanvas.style.display = 'block'
    pieCanvas.style.margin = 0 + 'auto'
    pieCanvas.style.marginRight = 'auto'
    pieCanvas.style.marginLeft = 'auto'
    pieCanvas.style.webkitTapHighlightColor = 'transparent'

    let width = pieCanvas.width
    let height = pieCanvas.height
    let progress = 1

    //chartOptions
    let chartOptions = {
      center: {
        x: width / 2,
        y: height / 2
      },
      outterCircleRadius: pieCanvas.width / 2.5
    }

    //Ratio
    chartOptions.ratioOutterCircle = chartOptions.outterCircleRadius / 155
    chartOptions.innerCircleRadius = Math.floor(40 * chartOptions.ratioOutterCircle)
    chartOptions.radius = Math.floor(40 * chartOptions.ratioOutterCircle)
    chartOptions.centeroffset = Math.floor(9 * chartOptions.ratioOutterCircle)
    chartOptions.labelBorderRadius = Math.floor(140 * chartOptions.ratioOutterCircle)

    let pieSections = [
      {
        score: this.props.scores[0],
        category: 'food_safety'
      },

      {
        score: this.props.scores[1],
        category: 'transparency'
      },
      {
        score: this.props.scores[2],
        category: 'animal_welfare'
      },
      {
        score: this.props.scores[3],
        category: 'human_rights'
      },

      {
        score: this.props.scores[4],
        category: 'environment'
      },
      {
        score: this.props.scores[5],
        category: 'nutrition'
      },
      {
        score: this.props.scores[6],
        category: 'processing'
      }
    ]

    let grerenScore = Math.floor(pieSections.reduce((sum, value) => sum + value.score, 0) / 7 + 0.5)

    let description = document.getElementById('home-chart-description')
    let fontSize = 1 * chartOptions.ratioOutterCircle
    //description.style.top = 280 + 'px';
    //description.innerHTML = "GreenScores can help you easily identify products that align with your values! Select any GreenScore category to view a description.";
    //description.style.fontFamily = "Overpass";
    //description.style.textAlign = "center";
    description.style.color = '#ffffff'
    description.style.wordBreak = 'break-word'
    description.style.display = 'inline-block'

    let maxPieScore = pieSections.reduce((max = 0, value) => {
      return value.score > max ? value.score : max
    }, 1)

    // pieCanvas.style.boxShadow = "1px 1px 20px #777777";
    //pieCanvas.style.backgroundColor = '#ffffff';

    let ctx = pieCanvas.getContext('2d')
    //let ctx2 = pieCanvas2.getContext("2d");

    let timer,
      n = 0

    // window.addEventListener("resize", handleResize);
    // function handleResize() {
    //   pieCanvas.style.width =  this.getLength() + 'px';
    //   pieCanvas.style.height = this.getLength() + 'px';
    // }

    function pieChartFrame(progress, indexPass, draw) {
      ctx.clearRect(0, 0, width, height)

      //New display delpoyment 10/24

      drawBaseCircle(ctx, chartOptions, chartbaseCircleColor)
      drawPiesBase(ctx, chartOptions, chartbaseCircleColor)
      drawPies(ctx, chartOptions, pieSections, progress, indexPass, draw)
      drawCenterCircle(ctx, chartOptions)
      setTimeout(drawCategoryTextImage(ctx), 400)
      setTimeout(drawCategoryIconsImage(ctx), 90)
      avgScoreFrame(ctx, chartOptions)
    }

    function drawPieChart(timestamp) {
      let step = 3
      pieChartFrame(progress)
      progress += step

      if (progress < 100 - step) {
        window.requestAnimationFrame(drawPieChart)
      } else {
        pieChartFrame(100)
        //showDescription(pieCanvas)
        setTimeout(showDescription(pieCanvas), 2500)

        //showScoreTip(pieCanvas)
        drawCategoryTextImage(ctx)
        mouseInEffect(pieCanvas)
        //pieCanvas.addEventListener('mousemove',mouseHoverHandler);
      }
    }

    this.pieSections = pieSections

    setTimeout(() => {
      window.requestAnimationFrame(drawPieChart)
    }, 90)

    function showScoreTip(canvas) {
      let tip = document.createElement('div')
      tip.style.background = 'rgba(32, 66, 31, .7)'
      tip.style.color = '#fff'
      tip.style.borderRadius = '2px'
      tip.style.fontFamily = 'Overpass'
      tip.style.padding = '5px 10px'
      tip.style.position = 'absolute'
      tip.style.zIndex = '999'
      tip.style.display = 'none'

      document.body.appendChild(tip)

      canvas.addEventListener('mousemove', e => {
        let crd = {
          x: e.offsetX * 2,
          y: e.offsetY * 2
        }
        let count = 0
        pieSections.forEach(pieSection => {
          if (pieSection.isInPath(crd, pieSection, pieChartFrame)) {
            //document.getElementById("xycoordinates").innerHTML = "Coordinates: (" + crd.x + "," + crd.y + ") scorePoint: (" + pieSection.score  + ")";
            let fontSize = 1 * chartOptions.ratioOutterCircle
            // tip.innerHTML = `<font font='helvatica'size='4vw'>${pieSection.category}</font>`;
            if (pieSection.score >= 0 && pieSection.score != null)
              tip.innerHTML = "<font size='5'> " + pieSection.score + '</font>'
            else tip.innerHTML = "<font size='4.4'> N/A </font>"
            tip.style.left = e.pageX + 15 + 'px'
            tip.style.top = e.pageY + 10 + 'px'
            tip.style.display = 'block'
          } else {
            count++
          }
          count === 7 && (tip.style.display = 'none')
        })
      })

      canvas.addEventListener('mousedown', e => {
        e.preventDefault()
        let crd = {
          x: e.offsetX * 2,
          y: e.offsetY * 2
        }
        let count = 0
        pieSections.forEach(pieSection => {
          if (pieSection.isInPath(crd, pieSection, pieChartFrame)) {
            //document.getElementById("xycoordinates").innerHTML = "Coordinates: (" + crd.x + "," + crd.y + ") scorePoint: (" + pieSection.score  + ")";
            let fontSize = 1 * chartOptions.ratioOutterCircle
            // tip.innerHTML = `<font font='helvatica'size='4vw'>${pieSection.category}</font>`;
            if (pieSection.score >= 0 && pieSection.score != null)
              tip.innerHTML = "<font size='+0.5'><font size='+1.3'> " + pieSection.score + '</font>'
            else tip.innerHTML = "<font size='+0.5'><font size='+1.3'> N/A </font>"
            tip.style.left = e.pageX + 15 + 'px'
            tip.style.top = e.pageY + 10 + 'px'
            tip.style.display = 'block'
          } else {
            count++
          }
          count === 7 && (tip.style.display = 'none')
        })
      })

      canvas.addEventListener('touchend', () => {
        tip.style.display = 'none'
      })
    }

    function showDescription(canvas) {
      let description = document.getElementById('home-chart-description')
      let positiveList = document.getElementById('positiveList')
      let netrualList = document.getElementById('netrualList')

      //description.style.background = '#fff';
      description.style.color = '#124B5F'
      //positiveList.style.color = '#F7F1E3';
      description.style.borderRadius = '2px'
      description.style.padding = '5px 10px'
      //description.style.position = 'absolute';
      description.style.textAlign = 'center'
      //description.style.span.display = "inline-flex";
      // description.style.margin = 0 + "auto";
      // description.style.display = "flex"
      // description.style.marginRight = "auto";
      // description.style.marginLeft = "auto";
      // description.style.display = "table-cell";
      // description.style.verticalAlign = "middle";
      description.style.width = 280
      //description.style.marginLeft = 15+ '%';
      //description.style.fontFamily = "Overpass";

      var timeout

      canvas.addEventListener('mousemove', e => {
        clearTimeout(timeout)
        let crd = {
          x: e.offsetX * 2,
          y: e.offsetY * 2
        }
        let count = 0

        var listwidth = 540
        if (window.innerWidth < 600) listwidth = 280
        else if (window.innerWidth < 350) listwidth = 230
        e.preventDefault()

        pieSections.forEach(pieSection => {
          if (pieSection.isInPath(crd, pieSection, pieChartFrame)) {
            //document.getElementById("xycoordinates").innerHTML = "Coordinates: (" + crd.x + "," + crd.y + ") scorePoint: (" + pieSection.score  + ")";
            let fontSize = 1 * chartOptions.ratioOutterCircle
            //let FoodCategory = "Meat";
            //let CategoryName = `${pieSection.category}`;
            //let CurrentScore = `${pieSection.score}`;

            if (returnComparedDescrption(pieSection.category) != null && pieSection.score > 0) {
              // description.innerHTML = returnComparedDescrption(
              //   pieSection.category
              // );
              var list = returnComparedDescrption(pieSection.category)

              var listPositive = ''
              var listNeutral = ''
              var listNegative = ''
              var listAlert = ''
              for (var i = 0; i < list.length; i++) {
                if (list[i].descriptionType === 'positive')
                  listPositive +=
                    '<tr ><td valign=\'top\'><img align=\'top\' src = \'https://uploads.codesandbox.io/uploads/user/4a22f8ed-bdd2-494a-a7ee-95e90c5b569a/jHcl-smiling-face.png\' height=\'24\' width=\'24\' /></td>' +
                    '<td align=\'left\'>' +
                    list[i].description +
                    '</td></tr>'
                else if (list[i].descriptionType === 'neutral')
                  listNeutral +=
                    '<tr ><td valign=\'top\'> <img src = \'https://uploads.codesandbox.io/uploads/user/4a22f8ed-bdd2-494a-a7ee-95e90c5b569a/OzZB-neutral-face.png\' height=\'24\' width=\'24\' /></td>' +
                    '<td align=\'left\'>' +
                    list[i].description +
                    '</td></tr>'
                else if (list[i].descriptionType === 'negative')
                  listNegative +=
                    '<tr ><td valign=\'top\'><img  src = \'https://uploads.codesandbox.io/uploads/user/4a22f8ed-bdd2-494a-a7ee-95e90c5b569a/3YwJ-disappointed-face.png\' height=\'24\' width=\'24\' /></td>' +
                    '<td align=\'left\'>' +
                    list[i].description +
                    '</td></tr>'
                else if (list[i].descriptionType === 'alert')
                  listAlert +=
                    '<tr><td><img src = \'https://uploads.codesandbox.io/uploads/user/4a22f8ed-bdd2-494a-a7ee-95e90c5b569a/8eRt-alert.png\' height=\'24\' width=\'24\' /></td>' +
                    '<td align=\'left\'>' +
                    list[i].description +
                    '</td></tr>'
              }
              description.innerHTML =
                '<table width=' + listwidth + ' >' + listPositive + listNeutral + listNegative + listAlert + '</table>'
            } else if (
              pieSection.category === 'human_rights' ||
              pieSection.category === 'animal_welfare' ||
              pieSection.category === 'transparency'
            ) {
              description.innerHTML =
                "<table align='center' style='border-spacing: 14px' width='" +
                listwidth +
                "' >" +
                "<tr><td valign='top'><img src = 'https://uploads.codesandbox.io/uploads/user/4a22f8ed-bdd2-494a-a7ee-95e90c5b569a/jG_w-construction-worker.png' height='24' width='24' /></td>" +
                "<td align='left'>" +
                ' This scoring system is still under development. ' +
                '</td></tr> </table > '
            } else if (pieSection.score === 0 || pieSection.score == null) {
              description.innerHTML =
                "<table align='center' style='border-spacing: 14px' width='" +
                listwidth +
                "' >" +
                "<tr ><td valign='top'>" +
                "<img src = 'https://uploads.codesandbox.io/uploads/user/4a22f8ed-bdd2-494a-a7ee-95e90c5b569a/uu1j-speech-balloon.png' height='24' width='24' /></td>" +
                "<td align='left'>  Insufficient data to score at this time. " +
                '</td></tr> </table > '
            }
            //description.innerHTML = pieSection.description;
            // description.style.top = 50 + '%';
            description.style.display = 'inline-block'
            description.style.wordBreak = 'break-word'
            //description.style.fontFamily = "Overpass";
            description.style.textAlign = 'center'
            description.style.display = 'block'
            //description.style.position = 'absolute'
            //description.style.width = 50 + '%';
            //description.style.marginLeft = 5+ '%';
          } else {
            count++
          }
          //count === 6 && (description.style.display = 'none');
        })
      })

      canvas.addEventListener('mousedown', e => {
        clearTimeout(timeout)
        let crd = {
          x: e.offsetX * 2,
          y: e.offsetY * 2
        }
        let count = 0
        var listwidth = 540
        if (window.innerWidth < 600) listwidth = 280
        else if (window.innerWidth < 350) listwidth = 230

        pieSections.forEach(pieSection => {
          if (pieSection.isInPath(crd, pieSection, pieChartFrame)) {
            //document.getElementById("xycoordinates").innerHTML = "Coordinates: (" + crd.x + "," + crd.y + ") scorePoint: (" + pieSection.score  + ")";
            let fontSize = 1 * chartOptions.ratioOutterCircle
            //let FoodCategory = "Meat";
            //let CategoryName = `${pieSection.category}`;
            //let CurrentScore = `${pieSection.score}`;

            //description.innerHTML = `${pieSection.description}`;
            if (returnComparedDescrption(pieSection.category) != null && pieSection.score > 0) {
              // description.innerHTML = returnComparedDescrption(
              //   pieSection.category
              // );
              var list = returnComparedDescrption(pieSection.category)

              var listPositive = ''
              var listNeutral = ''
              var listNegative = ''
              var listAlert = ''
              for (var i = 0; i < list.length; i++) {
                if (list[i].descriptionType === 'positive')
                  listPositive +=
                    '<tr ><td valign=\'top\'><img align=\'top\' src = \'https://uploads.codesandbox.io/uploads/user/4a22f8ed-bdd2-494a-a7ee-95e90c5b569a/jHcl-smiling-face.png\' height=\'24\' width=\'24\' /></td>' +
                    '<td align=\'left\'>' +
                    list[i].description +
                    '</td></tr>'
                else if (list[i].descriptionType === 'neutral')
                  listNeutral +=
                    '<tr ><td valign=\'top\'> <img src = \'https://uploads.codesandbox.io/uploads/user/4a22f8ed-bdd2-494a-a7ee-95e90c5b569a/OzZB-neutral-face.png\' height=\'24\' width=\'24\' /></td>' +
                    '<td align=\'left\'>' +
                    list[i].description +
                    '</td></tr>'
                else if (list[i].descriptionType === 'negative')
                  listNegative +=
                    '<tr ><td valign=\'top\'><img  src = \'https://uploads.codesandbox.io/uploads/user/4a22f8ed-bdd2-494a-a7ee-95e90c5b569a/3YwJ-disappointed-face.png\' height=\'24\' width=\'24\' /></td>' +
                    '<td align=\'left\'>' +
                    list[i].description +
                    '</td></tr>'
                else if (list[i].descriptionType === 'alert')
                  listAlert +=
                    '<tr><td><img src = \'https://uploads.codesandbox.io/uploads/user/4a22f8ed-bdd2-494a-a7ee-95e90c5b569a/8eRt-alert.png\' height=\'24\' width=\'24\' /></td>' +
                    '<td align=\'left\'>' +
                    list[i].description +
                    '</td></tr>'
              }
              description.innerHTML =
                '<table width=' + listwidth + ' >' + listPositive + listNeutral + listNegative + listAlert + '</table>'
            } else if (
              pieSection.category === 'human_rights' ||
              pieSection.category === 'animal_welfare' ||
              pieSection.category === 'transparency'
            ) {
              description.innerHTML =
                "<table align='center' style='border-spacing: 14px' width='" +
                listwidth +
                "' >" +
                "<tr><td valign='top'><img src = 'https://uploads.codesandbox.io/uploads/user/4a22f8ed-bdd2-494a-a7ee-95e90c5b569a/jG_w-construction-worker.png ' height='24 ' width='24' /></td>" +
                "<td align='left'>" +
                ' This scoring system is still under development. ' +
                '</td></tr> </table > '
            } else if (pieSection.score === 0 || pieSection.score == null) {
              description.innerHTML =
                "<table align='center' style='border-spacing: 14px' width='" +
                listwidth +
                "' >" +
                "<tr ><td valign='top'>" +
                "<img src = 'https://uploads.codesandbox.io/uploads/user/4a22f8ed-bdd2-494a-a7ee-95e90c5b569a/uu1j-speech-balloon.png ' height='24' width='24' /></td>" +
                "<td align='left'>  Insufficient data to score at this time. " +
                '</td></tr> </table > '
            }
            //description.innerHTML = pieSection.description;
            // description.style.top = 50 + '%';
            description.style.display = 'inline-block'
            description.style.wordBreak = 'break-word'
            //description.style.fontFamily = "Overpass";
            description.style.textAlign = 'center'
            description.style.display = 'block'
            //description.style.position = 'absolute'
            //description.style.width = 50 + '%';
            //description.style.marginLeft = 5+ '%';
          } else {
            count++
          }
          //count === 6 && (description.style.display = 'none');
        })
      })

      canvas.addEventListener('mouseleave', () => {
        description.style.display = 'none'
        clearTimeout(timeout)
      })

      canvas.addEventListener('touchcancel', e => {
        description.style.display = 'none'
        clearTimeout(timeout)
      })

      canvas.addEventListener('mousedown', e => {
        timeout = setTimeout(function() {
          description.style.display = 'none'
        }, 3710)
      })
    }

    function mouseInEffect(canvas) {
      var timeout

      canvas.addEventListener('mousemove', e => {
        clearTimeout(timeout)
        let crd = {
          x: e.offsetX * 2,
          y: e.offsetY * 2
        }
        let count = 0
        e.preventDefault()

        pieSections.forEach(pieSection => {
          if (pieSection.isInPath(crd, pieSection, pieChartFrame)) {
            pieCanvas.style.cursor = 'pointer'
            pieSection.mouseIn = true
            pieChartFrame(100, pieSection.index, false)
            //pieChartFrame(100, pieSection.index, true);

            ctx.save()
            let fillStyle = `hsl(${pieSection.pieColorHsl.h},${pieSection.pieColorHsl.s + 3}%,${pieSection.pieColorHsl
              .l + 20}%)`
            if (pieSection.score == null || pieSection.score > 100) {
              fillStyle = 'hsl(0,0%,86%)'
            }
            pieSection.isInPath2(crd, pieSection, pieChartFrame)

            ctx.shadowColor = 'rgb(132, 154, 155)'
            ctx.shadowBlur = 5
            ctx.shadowOffsetX = 3
            ctx.shadowOffsetY = 5
            ctx.fillStyle = fillStyle
            ctx.fill()
            ctx.restore()
            drawLableBorderMoouseIn(ctx, chartOptions, pieSection, pieSection.pieColor)
            drawCategoryIconsImage(ctx)
            drawCenterCircle(ctx, chartOptions)
            scoreFrameNew(ctx, chartOptions, pieSection.score)
            pieCanvas.style.userSelect = 'none'
          } else {
            count++
          }

          if (count === 7) {
            pieCanvas.style.cursor = 'auto'
          }
        })
      })

      canvas.addEventListener('mousedown', e => {
        clearTimeout(timeout)
        e.preventDefault()
        let crd = {
          x: e.offsetX * 2,
          y: e.offsetY * 2
        }
        let count = 0
        pieSections.forEach(pieSection => {
          if (pieSection.isInPath(crd, pieSection, pieChartFrame)) {
            pieCanvas.style.cursor = 'pointer'
            pieSection.mouseIn = true
            pieChartFrame(100, pieSection.index, false)
            //pieChartFrame(100, pieSection.index, true);

            ctx.save()
            let fillStyle = `hsl(${pieSection.pieColorHsl.h},${pieSection.pieColorHsl.s + 3}%,${pieSection.pieColorHsl
              .l + 20}%)`
            if (pieSection.score == null || pieSection.score > 100) {
              fillStyle = 'hsl(0,0%,86%)'
            }
            pieSection.isInPath2(crd, pieSection, pieChartFrame)

            ctx.shadowColor = 'rgb(132, 154, 155)'
            ctx.shadowBlur = 5
            ctx.shadowOffsetX = 3
            ctx.shadowOffsetY = 5
            ctx.fillStyle = fillStyle
            ctx.fill()
            ctx.restore()
            drawLableBorderMoouseIn(ctx, chartOptions, pieSection, pieSection.pieColor)
            drawCenterCircle(ctx, chartOptions)
            scoreFrameNew(ctx, chartOptions, pieSection.score)
            drawCategoryIconsImage(ctx)
          } else {
            count++
          }

          if (count === 7) {
            pieCanvas.style.cursor = 'auto'
          }
        })
      })

      canvas.addEventListener('touchcancel', e => {
        pieChartFrame(progress)
        clearTimeout(timeout)
      })

      canvas.addEventListener('mouseleave', e => {
        pieChartFrame(progress)
        clearTimeout(timeout)
      })

      canvas.addEventListener('mousedown', e => {
        timeout = setTimeout(function() {
          pieChartFrame(progress)
        }, 3710)
      })
    }

    //New Function called avgScoreFrame()
    function avgScoreFrame(ctx, chartOptions) {
      ctx.save()
      // 100 sacle
      //let score = Math.floor(greenScore * n / 100);

      // if (maxPieScore > progress) {
      //   score = Math.floor((greenScore * progress) / maxPieScore);
      // } else {
      //   score = greenScore;
      // }

      let score = getTotalGreenScore()

      //fontColor
      ctx.fillStyle = '#20421f' //'rgb(66, 70, 76)';
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.font = `600 ${Math.floor(13 * chartOptions.ratioOutterCircle)}px helvetica`
      // ctx.fillText('GreenScore', chartOptions.center.x, chartOptions.center.y + Math.floor(20 * chartOptions.ratioOutterCircle));
      ctx.shadowColor = 'rgba(140,140,140,1)'
      ctx.shadowBlur = Math.floor(2 * chartOptions.ratioOutterCircle)
      ctx.shadowOffsetX = Math.floor(1 * chartOptions.ratioOutterCircle)
      ctx.shadowOffsetY = Math.floor(1 * chartOptions.ratioOutterCircle)

      let hsl = calColor(score)
      ctx.fillStyle = `hsl(${hsl.h},${hsl.s}%,${hsl.l}%)`

      ctx.font = `${Math.floor(48 * chartOptions.ratioOutterCircle)}px helvetica`
      //With GreenSocre Text
      //ctx.fillText(score.toFixed(0), chartOptions.center.x, chartOptions.center.y - Math.floor(10 * chartOptions.ratioOutterCircle));

      //WithOut GreenScore text
      ctx.fillText(score.toFixed(0), chartOptions.center.x, chartOptions.center.y)
      ctx.restore()
    }

    //New Function called avgScoreFrame()to calculate the singe GS system score
    function scoreFrameNew(ctx, chartOptions, greenScore) {
      ctx.save()

      let score = greenScore

      //fontColor
      //ctx.fillStyle = "#20421f"; //'rgb(66, 70, 76)';

      //fontStyle
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.font = `600 ${Math.floor(13 * chartOptions.ratioOutterCircle)}px helvetica`

      let hsl = calColor(score)

      ctx.fillStyle = `hsl(${hsl.h},${hsl.s}%,${hsl.l}%)`

      ctx.font = `${Math.floor(48 * chartOptions.ratioOutterCircle)}px helvetica`

      if (greenScore == null) {
        ctx.fillStyle = 'hsl(0,0%,46%)'
        ctx.font = `${Math.floor(38 * chartOptions.ratioOutterCircle)}px helvetica`
        ctx.fillText('N/A', chartOptions.center.x, chartOptions.center.y)
      } else ctx.fillText(score.toFixed(0), chartOptions.center.x, chartOptions.center.y)

      ctx.restore()
    }

    function getTotalGreenScore() {
      var totalGreenScore = 0
      var totalNum = 0

      for (var i = 0; i < pieSections.length; i++) {
        if (pieSections[i].score >= 0 && pieSections[i].score != null && pieSections[i].score <= 100) {
          totalGreenScore += pieSections[i].score
          totalNum++
        }
      }

      return Math.round(totalGreenScore / totalNum)
    }

    //New Text Play function 10/24
    //Fixed the disappering problem 1/24
    function drawCategoryTextImage(ctx) {
      ctx.save()

      var imageObj1 = new Image()
      //imageObj1.src = "https://static.wixstatic.com/media/068bd9_c6ca66f7788b45308ae4c427bcc993e1~mv2.png";
      //imageObj1.src = pic1
      imageObj1.src = 'https://i.imgur.com/AAaweKP.png'

      //imageObj1.src = 'torta_copy2.svg'
      if (imageObj1.complete) {
        ctx.drawImage(
          imageObj1,
          pieCanvas.width / 21,
          pieCanvas.height / 21,
          pieCanvas.width * 0.91,
          pieCanvas.height * 0.91
        )

        ctx.restore()
      }
      //ctx.drawImage(imageObj1,40,40,720,720);

      imageObj1.onload = function() {
        ctx.drawImage(
          imageObj1,
          pieCanvas.width / 21,
          pieCanvas.height / 21,
          pieCanvas.width * 0.91,
          pieCanvas.height * 0.91
        )

        ctx.restore()
      }
    }

    function drawCategoryIconsImage(ctx) {
      ctx.save()

      var imageObj1 = new Image()
      imageObj1.src = 'https://i.imgur.com/MhntJTW.png'

      if (imageObj1.complete) {
        ctx.drawImage(
          imageObj1,
          pieCanvas.width / 21,
          pieCanvas.height / 21,
          pieCanvas.width * 0.91,
          pieCanvas.height * 0.91
        )

        ctx.restore()
      }
      //ctx.drawImage(imageObj1,40,40,720,720);

      imageObj1.onload = function() {
        ctx.drawImage(
          imageObj1,
          pieCanvas.width / 21,
          pieCanvas.height / 21,
          pieCanvas.width * 0.91,
          pieCanvas.height * 0.91
        )

        ctx.restore()
      }
    }

    function returnComparedDescrption(categoryValue) {
      var description = null
      for (var i = 0; i < descriptions.length; i++) {
        if (descriptions[i].category === categoryValue) {
          description = descriptions[i].description
          return description
        }
      }
    }
  }

  render() {
    return (
      <div id="container">
        <div>
          <canvas id="pieCanvas" />
        </div>
        <div id="home-chart-description" />
      </div>
    )
  }
}

function rot(x, y, angle, offset) {
  var rad = angle * (Math.PI / 180)
  let point = {
    x: x + offset * Math.cos(rad),
    y: y - offset * Math.sin(rad)
  }
  return point
}

function drawPies(ctx, chartOptions, pieSections, n, indexPass, draw) {
  ctx.save()
  let pieCount = pieSections.length
  ctx.setLineDash([])
  ctx.lineJoin = 'round'
  ctx.lineCap = 'round'
  ctx.lineWidth = 1

  for (let i = 0; i < pieCount; i++) {
    if (typeof indexPass === 'number') {
      if (draw) {
        if (indexPass !== i) continue
      } else {
        if (indexPass === i) continue
      }
    }

    //default h = 0
    let h = 0
    // hight of Pie
    // Fix the statment to judge the length at 1/10
    // The null will be 1st, then number 0-9, then will be regular number
    if (pieSections[i].score < 0 || pieSections[i].score == null) {
      h = 100
    } else if (pieSections[i].score >= 0 && pieSections[i].score < 15) {
      h = 15
    } else if (pieSections[i].score > n) {
      h = n
    } else {
      h = pieSections[i].score
    }
    let pieHeight = Math.floor(h * chartOptions.ratioOutterCircle)

    //Display color with N/A case. 2018/12/12
    let hsl = calColor(h)
    let color = `hsl(${hsl.h},${hsl.s}%,${hsl.l}%)`
    let geryColor = 'hsl(0,0%,71%)'
    if (pieSections[i].score >= 0 && pieSections[i].score != null) {
      //let color =calColorNew(h)
      ctx.fillStyle = color
    } else {
      ctx.fillStyle = geryColor
    }

    //TODO refect here
    // let angle = pieSections[i].angle || (- 60 * i + 60);
    let angle = pieSections[i].angle || -51.4 * i + 36.9
    //new center of pie
    let offset =
      pieSections[i].centerCrd ||
      rot(chartOptions.center.x, chartOptions.center.y, angle - 30, chartOptions.centeroffset)
    ctx.beginPath()
    let radius = pieSections[i].radius || chartOptions.innerCircleRadius + pieHeight

    let point1 = pieSections[i].baseLine
      ? pieSections[i].baseLine.point1
      : rot(offset.x, offset.y, angle, chartOptions.innerCircleRadius)
    ctx.moveTo(point1.x, point1.y)

    let point2 = rot(offset.x, offset.y, angle, radius)
    ctx.lineTo(point2.x, point2.y)
    ctx.arc(offset.x, offset.y, radius, (-angle / 360) * Math.PI * 2, ((-angle + 51) / 360) * Math.PI * 2, false)

    // let point3 = rot(offset.x, offset.y, angle - 51 , radius);
    // ctx.lineTo(point3.x, point3.y);

    let point4 = pieSections[i].baseLine
      ? pieSections[i].baseLine.point4
      : rot(offset.x, offset.y, angle - 51, chartOptions.innerCircleRadius)
    ctx.lineTo(point4.x, point4.y)
    ctx.arc(
      offset.x,
      offset.y,
      chartOptions.innerCircleRadius,
      ((-angle + 51) / 360) * Math.PI * 2,
      (-angle / 360) * Math.PI * 2,
      true
    )

    ctx.closePath()

    ctx.shadowColor = 'rgb(54, 56, 65)'
    ctx.shadowBlur = 22
    ctx.shadowOffsetX = 0
    ctx.shadowOffsetY = 0
    ctx.fill()

    if (h === pieSections[i].score && !pieSections[i].radius) {
      pieSections[i].pieColorHsl = hsl
      pieSections[i].pieColor = color
      pieSections[i].radius = radius
      pieSections[i].baseLine.point2 = point2
      pieSections[i].baseLine.point3 = rot(
        pieSections[i].centerCrd.x,
        pieSections[i].centerCrd.y,
        pieSections[i].angle - 51,
        chartOptions.innerCircleRadius + pieHeight
      )
      //pieSections[i].mouseIn = false;

      /*
       * Special Case added at 16,18/12/2018
       *  0-10: The pie chart radius will become like value 10 so user can see the score.
       *  null/ value <0 : It will become grey and will fill all pie chart of GS system
       */
      pieSections[i].isInPath = (crd, pieSection, pieChartFrame) => {
        ctx.save()
        ctx.beginPath()
        let radius = pieSection.radius
        let point1 = pieSection.baseLine.point1
        ctx.moveTo(point1.x, point1.y)
        let point2 = pieSection.baseLine.point2
        ctx.lineTo(point2.x, point2.y)
        ctx.arc(
          pieSection.centerCrd.x,
          pieSection.centerCrd.y,
          chartOptions.innerCircleRadius + Math.floor(100 * chartOptions.ratioOutterCircle),
          (-pieSection.angle / 360) * Math.PI * 2,
          ((-pieSection.angle + 51) / 360) * Math.PI * 2,
          false
        )
        // let point3 = pieSection.baseLine.point3;
        // ctx.lineTo(point3.x, point3.y);
        let point4 = pieSection.baseLine.point4
        ctx.lineTo(point4.x, point4.y)
        ctx.arc(
          pieSection.centerCrd.x,
          pieSection.centerCrd.y,
          chartOptions.innerCircleRadius,
          ((-pieSection.angle + 51) / 360) * Math.PI * 2,
          (-pieSection.angle / 360) * Math.PI * 2,
          true
        )

        let isIn = ctx.isPointInPath(crd.x, crd.y)

        if (pieSection.mouseIn && !isIn) {
          pieSection.mouseIn = false
          //rerender whole chart
          pieChartFrame(100)
        }
        ctx.closePath()
        ctx.restore()
        return isIn
      }

      pieSections[i].isInPath2 = (crd, pieSection, pieChartFrame) => {
        ctx.save()
        ctx.beginPath()
        let radius = pieSection.radius
        let point1 = pieSection.baseLine.point1
        ctx.moveTo(point1.x, point1.y)
        let point2 = pieSection.baseLine.point2
        ctx.lineTo(point2.x, point2.y)
        ctx.arc(
          pieSection.centerCrd.x,
          pieSection.centerCrd.y,
          pieSection.radius,
          (-pieSection.angle / 360) * Math.PI * 2,
          ((-pieSection.angle + 51) / 360) * Math.PI * 2,
          false
        )
        // let point3 = pieSection.baseLine.point3;
        // ctx.lineTo(point3.x, point3.y);
        let point4 = pieSection.baseLine.point4
        ctx.lineTo(point4.x, point4.y)
        ctx.arc(
          pieSection.centerCrd.x,
          pieSection.centerCrd.y,
          chartOptions.innerCircleRadius,
          ((-pieSection.angle + 51) / 360) * Math.PI * 2,
          (-pieSection.angle / 360) * Math.PI * 2,
          true
        )

        ctx.closePath()
        ctx.restore()
      }
    } else if (pieSections[i].score === null || pieSections[i].score < 0) {
      pieSections[i].pieColorHsl = 'hsl(0,0%,46%)'
      pieSections[i].pieColor = 'hsl(0,0%,46%)'
      pieSections[i].radius = radius
      pieSections[i].isInPath = (crd, pieSection, pieChartFrame) => {
        ctx.save()
        ctx.beginPath()
        let radius = pieSection.radius
        //let point1 =  pieSection.baseLine.point1 ;
        ctx.moveTo(point1.x, point1.y)
        //let point2 = pieSection.baseLine.point2;
        ctx.lineTo(point2.x, point2.y)
        ctx.arc(
          pieSection.centerCrd.x,
          pieSection.centerCrd.y,
          pieSection.radius,
          (-pieSection.angle / 360) * Math.PI * 2,
          ((-pieSection.angle + 51) / 360) * Math.PI * 2,
          false
        )
        // let point3 = pieSection.baseLine.point3;
        // ctx.lineTo(point3.x, point3.y);
        let point4 = pieSection.baseLine.point4
        ctx.lineTo(point4.x, point4.y)
        ctx.arc(
          pieSection.centerCrd.x,
          pieSection.centerCrd.y,
          chartOptions.innerCircleRadius,
          ((-pieSection.angle + 51) / 360) * Math.PI * 2,
          (-pieSection.angle / 360) * Math.PI * 2,
          true
        )

        let isIn = ctx.isPointInPath(crd.x, crd.y)

        if (pieSection.mouseIn && !isIn) {
          pieSection.mouseIn = false
          //rerender whole chart
          pieChartFrame(100)
        }
        ctx.closePath()
        ctx.restore()
        return isIn
      }

      pieSections[i].isInPath2 = (crd, pieSection, pieChartFrame) => {
        ctx.save()
        ctx.beginPath()
        let radius = pieSection.radius
        //let point1 =  pieSection.baseLine.point1 ;
        ctx.moveTo(point1.x, point1.y)
        //let point2 = pieSection.baseLine.point2;
        ctx.lineTo(point2.x, point2.y)
        ctx.arc(
          pieSection.centerCrd.x,
          pieSection.centerCrd.y,
          pieSection.radius,
          (-pieSection.angle / 360) * Math.PI * 2,
          ((-pieSection.angle + 51) / 360) * Math.PI * 2,
          false
        )
        // let point3 = pieSection.baseLine.point3;
        // ctx.lineTo(point3.x, point3.y);
        let point4 = pieSection.baseLine.point4
        ctx.lineTo(point4.x, point4.y)
        ctx.arc(
          pieSection.centerCrd.x,
          pieSection.centerCrd.y,
          chartOptions.innerCircleRadius,
          ((-pieSection.angle + 51) / 360) * Math.PI * 2,
          (-pieSection.angle / 360) * Math.PI * 2,
          true
        )

        ctx.closePath()
        ctx.restore()
      }
    } else if (pieSections[i].score < 15 && pieSections[i].score >= 0) {
      pieSections[i].pieColorHsl = hsl
      pieSections[i].pieColor = color
      pieSections[i].radius = radius
      pieSections[i].isInPath = (crd, pieSection, pieChartFrame) => {
        ctx.save()
        ctx.beginPath()
        let radius = pieSection.radius
        //let point1 =  pieSection.baseLine.point1 ;
        ctx.moveTo(point1.x, point1.y)
        //let point2 = pieSection.baseLine.point2;
        ctx.lineTo(point2.x, point2.y)
        ctx.arc(
          pieSection.centerCrd.x,
          pieSection.centerCrd.y,
          chartOptions.innerCircleRadius + Math.floor(100 * chartOptions.ratioOutterCircle),
          (-pieSection.angle / 360) * Math.PI * 2,
          ((-pieSection.angle + 51) / 360) * Math.PI * 2,
          false
        )
        // let point3 = pieSection.baseLine.point3;
        // ctx.lineTo(point3.x, point3.y);
        let point4 = pieSection.baseLine.point4
        ctx.lineTo(point4.x, point4.y)
        ctx.arc(
          pieSection.centerCrd.x,
          pieSection.centerCrd.y,
          chartOptions.innerCircleRadius,
          ((-pieSection.angle + 51) / 360) * Math.PI * 2,
          (-pieSection.angle / 360) * Math.PI * 2,
          true
        )

        let isIn = ctx.isPointInPath(crd.x, crd.y)

        if (pieSection.mouseIn && !isIn) {
          pieSection.mouseIn = false
          //rerender whole chart
          pieChartFrame(100)
        }
        ctx.closePath()
        ctx.restore()
        return isIn
      }

      pieSections[i].isInPath2 = (crd, pieSection, pieChartFrame) => {
        ctx.save()
        ctx.beginPath()
        let radius = pieSection.radius
        //let point1 =  pieSection.baseLine.point1 ;
        ctx.moveTo(point1.x, point1.y)
        //let point2 = pieSection.baseLine.point2;
        ctx.lineTo(point2.x, point2.y)
        ctx.arc(
          pieSection.centerCrd.x,
          pieSection.centerCrd.y,
          pieSection.radius,
          (-pieSection.angle / 360) * Math.PI * 2,
          ((-pieSection.angle + 51) / 360) * Math.PI * 2,
          false
        )
        // let point3 = pieSection.baseLine.point3;
        // ctx.lineTo(point3.x, point3.y);
        let point4 = pieSection.baseLine.point4
        ctx.lineTo(point4.x, point4.y)
        ctx.arc(
          pieSection.centerCrd.x,
          pieSection.centerCrd.y,
          chartOptions.innerCircleRadius,
          ((-pieSection.angle + 51) / 360) * Math.PI * 2,
          (-pieSection.angle / 360) * Math.PI * 2,
          true
        )

        ctx.closePath()
        ctx.restore()
      }
    }

    if (!pieSections[i].centerCrd) {
      //offset
      pieSections[i].centerCrd = {
        x: offset.x,
        y: offset.y
      }
      pieSections[i].baseLine = {
        point1: point1,
        point4: point4
      }
      pieSections[i].angle = angle
      pieSections[i].index = i
    }
  }

  ctx.restore()
}

function drawPiesBase(ctx, chartOptions, fillStyle) {
  ctx.save()
  //draw line

  let pieCount = 7
  for (let i = 0; i < pieCount; i++) {
    let angle = -51.4 * i + 38.9
    let h = 100
    let pieHeight = Math.floor(h * chartOptions.ratioOutterCircle)

    //TODO ??????????????????????????
    ctx.fillStyle = fillStyle
    let offset = rot(chartOptions.center.x, chartOptions.center.y, angle - 55, chartOptions.centeroffset)
    ctx.beginPath()
    let radius = chartOptions.innerCircleRadius + pieHeight
    //could be use again
    let point1 = rot(offset.x, offset.y, angle, chartOptions.innerCircleRadius)
    ctx.moveTo(point1.x, point1.y)

    let point2 = rot(offset.x, offset.y, angle, radius)
    ctx.lineTo(point2.x, point2.y)

    ctx.arc(offset.x, offset.y, radius, (-angle / 360) * Math.PI * 2, ((-angle + 51.4) / 360) * Math.PI * 2, false)

    let point4 = rot(offset.x, offset.y, angle - 51.4, chartOptions.innerCircleRadius)
    ctx.lineTo(point4.x, point4.y)
    ctx.arc(
      offset.x,
      offset.y,
      chartOptions.innerCircleRadius,
      ((-angle + 51.4) / 360) * Math.PI * 2,
      (-angle / 360) * Math.PI * 2,
      true
    )

    ctx.closePath()
    ctx.fill()
  }

  ctx.shadowColor = 'rgba(0,0,0,0.8)'
  ctx.shadowBlur = 5
  ctx.shadowOffsetX = 3
  ctx.shadowOffsetY = 5
  ctx.restore()
}

function drawBaseCircle(ctx, chartOptions, chartbaseCircleColor, globalAlpha) {
  ctx.save()
  ctx.onselectstart = function() {
    return false
  }
  ctx.globalAlpha = globalAlpha || 1
  ctx.beginPath()
  ctx.zIndex = 999
  //ctx.fillStyle = chartbaseCircleColor;
  let pieHeight = Math.floor(110 * chartOptions.ratioOutterCircle)
  var circleRadius = chartOptions.innerCircleRadius + pieHeight
  ctx.fillStyle = 'white'
  ctx.arc(chartOptions.center.x, chartOptions.center.y, circleRadius, 0, Math.PI * 2, true)

  ctx.shadowColor = 'black'
  ctx.strokeStyle = 'rgba(0,0,0,1)'
  ctx.shadowBlur = 15
  ctx.shadowOffsetX = 0
  ctx.shadowOffsetY = 0

  ctx.closePath()
  ctx.fill()
  ctx.restore()
}

function getGreenScoreDisplay(GreenScore) {
  if (GreenScore >= 0 && GreenScore != null) return GreenScore
  else return 'N/A'
}

//New Center Circle in center 10/24
function drawCenterCircle(ctx, chartOptions) {
  ctx.save()
  //ctx.globalAlpha = globalAlpha || 1;
  ctx.beginPath()
  //ctx.zIndex = 999;
  ctx.fillStyle = '#f2f4f7'

  ctx.shadowColor = 'black'
  ctx.strokeStyle = 'rgba(0,0,0,1)'
  ctx.shadowBlur = 15
  ctx.shadowOffsetX = 0
  ctx.shadowOffsetY = 0

  ctx.arc(
    chartOptions.center.x,
    chartOptions.center.y,
    Math.floor(53 * chartOptions.ratioOutterCircle),
    0,
    Math.PI * 2,
    true
  )
  ctx.closePath()
  ctx.fill()
  ctx.restore()
}

function calColor(gs) {
  let h = gs * gs * 0.0105
  let s = 85
  let l = 65 - gs * gs * 0.0024

  return { h: h, s: s, l: l }
}

function isInPath(ctx, crd, x, y, r) {
  if (r < 0 && r == null) {
    r = 0
  }
  ctx.arc(x, y, r, 0, Math.PI * 2)
  let isInPath = ctx.isPointInPath(crd.x, crd.y)
  ctx.closePath()
  return isInPath
}

function drawBlock(ctx, chartOptions, chartbaseCircleColor, globalAlpha) {
  //innercircle
  ctx.save()
  ctx.globalAlpha = globalAlpha || 1
  ctx.beginPath()
  ctx.strokeStyle = 'rgba(132, 154, 155,0.8)'
  let shdowInset = 5
  ctx.arc(
    chartOptions.center.x,
    chartOptions.center.y,
    chartOptions.outterCircleRadius + shdowInset,
    0,
    Math.PI * 2,
    true
  )
  ctx.lineWidth = shdowInset + shdowInset
  ctx.closePath()
  ctx.shadowColor = 'rgba(132, 154, 155,0.4)'
  ctx.shadowBlur = Math.floor(14 * chartOptions.ratioOutterCircle)
  ctx.shadowOffsetX = Math.floor(5 * chartOptions.ratioOutterCircle)
  ctx.shadowOffsetY = Math.floor(3 * chartOptions.ratioOutterCircle)
  ctx.stroke()
  ctx.restore()

  //outercircleBlock
  ctx.save()
  ctx.beginPath()
  ctx.strokeStyle = 'white'
  //???????????????????????????????????????????????
  let outterCircleRadius = 1.2 * 150 * chartOptions.ratioOutterCircle
  let outterCircleWidth = 0.4 * 150 * chartOptions.ratioOutterCircle
  ctx.arc(chartOptions.center.x, chartOptions.center.y, outterCircleRadius, 0, Math.PI * 2, true)
  ctx.lineWidth = outterCircleWidth
  ctx.closePath()
  ctx.stroke()
  ctx.restore()

  //shinny refelection
  // ctx.beginPath();
  // ctx.arc(chartOptions.center.x,chartOptions.center.y, chartOptions.outterCircleRadius - 50 , - Math.PI / 6 , - Math.PI /3, true);
  // ctx.lineWidth = 30;
  // ctx.lineCap = 'round';
  // ctx.strokeStyle = 'rgba(20,20,255,0.7)';
  // ctx.stroke()
  // ctx.closePath();
  // ;
  // //ctx.fill();
  // ctx.restore();
}

function drawLableBorderMoouseIn(ctx, chartOptions, pieSection, bordercolor) {
  ctx.save()

  let angle = pieSection.angle
  ctx.strokeStyle = pieSection.pieColor
  ctx.beginPath()
  ctx.arc(
    pieSection.centerCrd.x,
    pieSection.centerCrd.y,
    chartOptions.labelBorderRadius,
    (-angle / 360) * Math.PI * 2,
    ((-angle + 51.4) / 360) * Math.PI * 2,
    false
  )
  ctx.strokeStyle = bordercolor
  if (window.innerWidth > 1100) {
    ctx.lineWidth = chartOptions.labelBorderRadius - chartOptions.outterCircleRadius + (window.innerWidth / 51) * 2
  } else if (window.innerWidth > 600) {
    ctx.lineWidth = chartOptions.labelBorderRadius - chartOptions.outterCircleRadius + (window.innerWidth / 29) * 2
  } else {
    ctx.lineWidth = chartOptions.labelBorderRadius - chartOptions.outterCircleRadius + (window.innerWidth / 18) * 2
  }
  ctx.stroke()
  ctx.closePath()
  ctx.restore()
}

export default PieChart



// WEBPACK FOOTER //
// ./src/components/PieChart.js